import { isValidCPF, isValidPIS } from 'utils/functions'
import * as yup from 'yup'

export const SCHEMA = {
  logicalEffectiveForm: yup
    .object({
      cdCep: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .max(9, 'Máximo 9 caracteres')
            .required('Informe o CEP')
        }),

      cdCpf: yup
        .string()
        .required('Informe o CPF/Passaporte')
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .test('cdCpf', 'CPF Inválido', (value) => {
              if (isNaN(parseInt(value))) return true
              return isValidCPF(value)
            })
        })
        .max(14, 'CPF/Passaporte Inválido'),

      cdCtps: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(4, 'Mínimo 4 caracteres')
            .max(13, 'Máximo 13 caracteres')
        }),

      cdDocumento: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(5, 'Mínimo 5 caracteres')
            .max(20, 'Máximo 20 caracteres')
            .required('Informe o RG')
        }),

      cdPis: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .max(14, 'Máximo 14 caracteres')
            .test('cdPis', 'PIS Inválido', (value) => {
              return isValidPIS(value)
            })
        }),

      cdSerieCtps: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(2, 'Mínimo 2 caracteres')
            .max(4, 'Máximo 4 caracteres')
        }),

      dtNascimento: yup
        .date()
        .typeError('Data inválida')
        .required('Informe a data de nascimento'),

      nmColaborador: yup
        .string()
        .min(5, 'Mínimo 5 caracteres')
        .max(50, 'Máximo 50 caracteres')
        .required('Informe o nome do colaborador'),

      sgEstadoCtps: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(2, 'Estado inválido.')
            .max(2, 'Máximo 2 letras')
        }),

      sgEstadoDocto: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(2, 'Estado inválido.')
            .max(2, 'Máximo 2 letras')
            .required('Informe o estado.')
        }),

      sgGenero: yup.string().required('Informe o Gênero'),

      txBairro: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(3, 'Mínimo 3 caracteres')
            .max(50, 'Máximo 50 caracteres')
            .required('Informe o Bairro')
        }),

      txCidade: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(3, 'Mínimo 3 caracteres')
            .max(50, 'Máximo 50 caracteres')
            .required('Informe a cidade.')
        }),

      txEmissorDocto: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(2, 'Mínimo 2 caracteres')
            .max(10, 'Máximo 10 caracteres')
            .required('Informe o Orgão Emissor')
        }),

      txEndereco: yup
        .string()
        .nullable()
        .when('txNacionalidade', {
          is: 'Brasileiro',
          then: yup.string()
            .min(5, 'Mínimo 5 caracteres')
            .max(50, 'Máximo 50 caracteres')
            .required('Informe o Endereço')
        }),

      txFiliacaoMae: yup
        .string()
        .min(5, 'Mínimo 5 caracteres')
        .max(50, 'Máximo 50 caracteres')
        .required('Informe o nome da mãe'),

      txFiliacaoPai: yup
        .string()
        .min(5, 'Mínimo 5 caracteres')
        .max(50, 'Máximo 50 caracteres')
        .required('Informe o nome do pai'),

      txFuncao: yup
        .string()
        .min(5, 'Mínimo 5 caracteres')
        .max(50, 'Máximo 50 caracteres')
        .required('Informe a função'),

      txNacionalidade: yup.string().required('Informe a Nacionalidade'),

      usaRefeitorio: yup.boolean().required('Informe sim ou não')
    })
    .required()
}
